<div class="users-page">
  <h1>Edit users</h1>

  @if (loading()) {
    <stena-skeleton-loader type="text" [rows]="3" />
  } @else {
    <form [formGroup]="form" class="picker">
      <stena-select
        class="dense-3"
        formControlName="userId"
        label="Select user"
        [options]="userOptions()"
      />
    </form>

    @if (selectedUser(); as user) {
      <section class="user-detail">
        <div class="user-header">
          <h2>{{ user.accessUserName }}</h2>
          <stena-button
            type="stroked"
            color="warn"
            text="Delete user"
            [disabled]="busy()"
            (buttonClick)="onDeleteUser()"
          />
        </div>

        <mat-checkbox
          class="daily-toggle"
          [checked]="user.accessDailyReporting"
          [disabled]="busy()"
          (change)="onToggleDailyReporting($event.checked)"
        >
          Grant access to daily reporting
        </mat-checkbox>

        <h3>Grant access to KPI area on cost center</h3>
        <form [formGroup]="form" class="grant-row">
          <stena-select
            class="dense-3"
            formControlName="newCostCenterId"
            label="Cost center"
            [options]="costCenterOptions()"
          />
          <stena-select
            class="dense-3"
            formControlName="newAreaId"
            label="KPI area"
            [options]="kpiAreaOptions()"
          />
          <stena-button
            type="raised"
            color="primary"
            text="Grant"
            [disabled]="busy()"
            (buttonClick)="onGrantAccess()"
          />
        </form>

        <h3>Current access</h3>
        @if (userAccess().length === 0) {
          <p class="hint">No cost center / area combinations granted yet.</p>
        } @else {
          <ul class="access-list">
            @for (
              row of userAccess();
              track row.costCenterId + '-' + row.areaId
            ) {
              <li class="access-row">
                <span class="access-label">
                  {{ row.costCenterName }} — {{ row.areaName }}
                </span>
                <stena-button
                  type="icon"
                  icon="delete"
                  color="warn"
                  [disabled]="busy()"
                  (buttonClick)="onRevoke(row)"
                />
              </li>
            }
          </ul>
        }
      </section>
    }
  }
</div>
